//
// PromptElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "@sas-dvr/ltjs-commons/models/data/DataValue";
import "../../models/visualElements/PromptElement";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "@sas-dvr/ltjs-commons/models/data/dataset/Column";
import "../../models/promptDefinitions/PromptDefinition";
import "@sas-dvr/ltjs-commons/models/prompt/MissingValueCheckboxLocationType";
import "@sas-dvr/ltjs-commons/models/prompt/MissingValueBehavior";

var PromptElementController = createModule("BIRD::PromptElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController","BIRD::DataVisualElementController"], EventDispatcher, [
    {
        CURRENT_VALUE_HAS_INVALID_FORMAT: 50016,
        CURRENT_VALUE_CHANGED: 50035,
        MISSING_DYNAMIC_VALUES: 50015,
        INVALID_PROMPTDEFINITION_MEASURE_VARIABLE: 50014,
    },
    ,
    ,
    {
        currentValuesInTermsOfOrderedUniqueRowIndices: [3],
        currentValues: [1],
        currentValue: 1,
    },
    {
        getFormattedMeasure: [7,4],
        setCurrentValuesAndMissingValueBehavior: [0,[1],4,2],
        getLabel: [7],
        saveState: [0],
        validateValue: [1,1],
        isSectionFilter: [2],
        getPromptDefinition: [1],
        getStyleChain: [1],
        getMissingValueCheckboxLocation: [4],
        getDefaultValue: [1],
        getDataValueForUserInput: [1,7],
        getFormatName: [7],
        getColumn: [1],
        getMissingValueBehavior: [4],
        getPromptDefinitionWithCurrentValueSource: [1],
        isRequired: [2],
        getModel: [1],
        isParameter: [2],
        getCurrentFormattedMeasure: [7],
        showTooltip: [0,[1],4,4],
        getMeasures: [[6]],
        getMeasureColumn: [1],
        getMeasureVariableLabel: [7],
        getUniqueRowIndicies: [[3]],
        getSelectionStyleChain: [1],
        sortByColumn: [0,7,4],
        setMissingValueBehavior: [0,4,2],
    },
    {
        _create: [4,1],
        getMissingDisplayString: [7],
    },
    ,
]);
export default PromptElementController;
